module.exports = __webpack_public_path__ + "static/media/088.76685e14.jpg";